import { ChangeDetectionStrategy, Component, inject, input, model } from '@angular/core';
import { Router } from '@angular/router';
import {
  SearchResultRenderer,
  SOFT_SHELL_SAVE_LAST_VIEWED,
  SOFT_SHELL_SEARCH_DISMISS,
} from '@softapps/core';
import { IconComponent } from '@softline/ui-core';

@Component({
  selector: 'soft-lieferantenstamm-search-result',
  imports: [IconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '(keydown.enter)': 'open(result())',
    '(click)': 'open(result())',
  },
  template: `
    @let item = result();
    <div class="flex items-center gap-2 w-full">
      <span
        class="flex items-center justify-center rounded-md min-w-8 min-h-8 bg-surface-secondary text-sm shrink-0"
      >
        <soft-icon name="fa-regular fa-truck" />
      </span>
      <div class="flex flex-col min-w-0 w-full">
        <span class="text-sm font-semibold truncate">
          {{ item?.name1 ?? item?.kurzbez ?? '' }}
        </span>
        <span class="text-xs text-light truncate">
          {{ item?.nummer ?? '' }}{{ item?.ort ? ' · ' + item.ort : '' }}
        </span>
      </div>
    </div>
  `,
})
export class LieferantenstammSearchResultComponent extends SearchResultRenderer<any> {
  override result = input.required<any>();
  override highlighted = input(false);
  override disabled = model(false);

  private readonly router = inject(Router);
  private readonly dismissSearchOverlay = inject(SOFT_SHELL_SEARCH_DISMISS);
  private readonly saveLastViewed = inject(SOFT_SHELL_SAVE_LAST_VIEWED, {
    optional: true,
  });

  async open(item: any): Promise<void> {
    if (!item) return;
    const id = item.id;
    this.saveLastViewed?.({
      key: String(id),
      number: String(item.nummer ?? ''),
      title: item.name1 ?? item.kurzbez ?? '',
      url: `/lieferantenstamm/${id}`,
    });
    this.dismissSearchOverlay();
    await this.router.navigate(['/lieferantenstamm', id], {
      fragment: 'allgemein',
    });
  }
}
